import React from "react";
import axios from "axios";
import './benefisciaryVerify.css';
import { connect } from "react-redux";
import FooterComponet from "../FooterComponent/FooterComponet";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class AccountVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            errorMessage: '',
            otpNo: '',
            loader: true,
            beneverified: false,
            accountAddSuccessMsg: ''
        }
    }

    componentDidMount() {
        this.setState({
            loader: true,
            errorMessage: '',
            accountAddSuccessMsg: ''
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        var addBenefisciaryRequest = this.props.benefisciaryRequest;
        var addBeneUrl = '/api/v1/payout/connector/addAccount';


        const request = {
            header: addBenefisciaryRequest.header,
            beneficiary: addBenefisciaryRequest.beneficiary,
            deviceInfo: this.props.deviceInfo,
            customerId: this.props.agentInfo.id,
            doVerification: true,
            agentId: this.props.agentInfo.id

        }


        console.log('request::' + JSON.stringify(request));

        httpClient.post(addBeneUrl, request, { headers }
        ).then((response) => {


            this.setState({
                loader: false
            })

            console.log('register bene response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {
                this.setState({
                    accountAddSuccessMsg: 'Account added successfully',
                    beneverified: true
                })

                var gotoMerchantPayoutPage = document.getElementById('gotoMerchantPayoutPage');
                setTimeout(() => {
                    gotoMerchantPayoutPage.click();
                }, 1000)
            }
            else if (response.data.response.msg == 'DOCUMENT_REQUIRED') {
                var accountImageUpload = document.getElementById('accountImageUpload');
                accountImageUpload.click();
            }
            else if (response.data.response.msg == 'FAIL') {
                this.setState({
                    errorMessage: response.data.response.displayMsg,
                    beneverified: false
                })


            } else {
                this.setState({
                    errorMessage: 'Something went wrong'
                })
            }
        }).catch(error => {
            this.setState({
                loader: false
            })
            this.errorMessageCall(error.message);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });

    }
    componentWillUnmount() {
    }

    enterOtp = (event) => {
        event.preventDefault();
        this.setState({
            otpNo: event.target.value
        })
    }



    errorMessageCall = (error) => {
        this.setState({
            errorMessage: error
        })
    }



    render() {
        return (

            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Beneficiary Details</h3>
                                                <div class="headbtn">
                                                    <Link to='/add-account'>
                                                        <button class="dbbtn" type="button">Back</button>
                                                    </Link>
                                                    <Link to='/add-account'>
                                                        <button id='addbeneficiaryBtn' hidden={true}></button>
                                                    </Link>
                                                    <Link to='/account-details'>
                                                        <button id='beneficiaryDetailsBtn' hidden={true}></button>
                                                    </Link>
                                                    <Link to='/doc-upload'>
                                                        <button id='accountImageUpload' hidden={true}></button>
                                                    </Link>
                                                    <Link to='/merchant-payout'>
                                                        <button id='gotoMerchantPayoutPage' hidden={true}></button>
                                                    </Link>

                                                </div>
                                            </div>

                                            <div class="status">
                                                {this.state.loader == true &&
                                                    <h3 class="pending" id="bnrun">Account Add Confirmation...</h3>
                                                }
                                                {this.state.loader == false &&
                                                    this.state.errorMessage == '' &&
                                                    this.state.beneverified == true &&
                                                    <h3 class="success" id="bndone">Account Add Confirmed</h3>
                                                }

                                                {this.state.loader == false &&
                                                    this.state.errorMessage != '' &&
                                                    this.state.beneverified != true &&
                                                    <h3 class="failed" id="bndone">Account Add Failed!</h3>
                                                }


                                            </div>
                                            <div class="benereviewcard">
                                                <div class="row">
                                                    <div class="col-12 col-md-4">
                                                        <div class="benedtl">
                                                            {/* <img src="images/sbi-bank.png" alt=""> */}
                                                            <h4>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryName}</h4>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.bankName}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-sm-6 col-md-4">
                                                        <div class="benedtl">
                                                            <h5>Account Number</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.accountNumber}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 col-sm-3 col-md-2">
                                                        <div class="benedtl">
                                                            <h5>Mobile Number</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryMobile}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 col-sm-3 col-md-2">
                                                        <div class="benedtl rtxt">
                                                            <h5>IFSC Code</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.ifscCode}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {this.state.loader == false &&
                                            this.state.errorMessage != '' &&
                                            <div class='valid-error'>
                                                {this.state.errorMessage}
                                            </div>
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponet />
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, benefisciaryRequest, addSenderRequest, ifscCode,
            generateOtpResponse, agentInfo, token, clientRole, selectSender, beneSubDetails,
            createOrderStatusResponse, beneVerifyOtp, beneCustomerId, beneRegisterResponse,
            callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, benefisciaryRequest, addSenderRequest,
    ifscCode, generateOtpResponse, agentInfo, token, clientRole, selectSender, beneSubDetails,
    createOrderStatusResponse, beneVerifyOtp, beneCustomerId, beneRegisterResponse,
    callBackUrl
});

export default connect(mapStateToProps, null)(AccountVerification);
